<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('kotBotPrinter.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('kotBotPrinter.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button outline color="info" @click.prevent="addNew">{{
            $t('add_new')
          }}</ts-button>
          <div class="d-flex ts-space-x-3 ts-items-center">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px;"
              class="inline-block"
            />
            <ts-filter ref="filter">
              <div class="row">
                <div class="col-md-12">
                  <label class="">{{ $t('kotBotPrinter.branchName') }}</label>
                  <ts-branch-filter
                    @filter="branchFilter"
                    class="ts-w-full"
                  ></ts-branch-filter>
                </div>
              </div>
            </ts-filter>
          </div>
        </div>
      </ts-card-wrapper>
      <Table
        :columns="columns"
        :data="groupResources"
        :span-method="handleSpan"
        row-key="index"
        size="small"
        :loading="loading"
        highlight-row
        stripe
        max-height="700"
      >
        <template #branch_name="{ row, index }">
          {{ row.branch ? row.branch.branch_name_en : '' }}
        </template>
        <template #product_group="{ row, index }">
          {{ row.pro_group ? row.pro_group.pro_group_name_en : '' }}
        </template>
        <template #printer_name="{ row, index }">
          <span
              v-if="
                row.branch_id != model.branch_id ||
                  row.pro_group_id != model.pro_group_id
              "
              >{{ row.printer_name }}</span
            >
            <input
              v-model="model.printer_name"
              type="text"
              class="form-control"
              v-if="
                row.branch_id == model.branch_id &&
                  row.pro_group_id == model.pro_group_id
              "
            />
        </template>
        <template #receipt_type="{ row, index }">
          <span
              v-if="
                row.branch_id != model.branch_id ||
                  row.pro_group_id != model.pro_group_id
              "
              >{{ row.receipt_type }}</span
            >
            <select
              v-model="model.receipt_type"
              v-if="
                row.branch_id == model.branch_id &&
                  row.pro_group_id == model.pro_group_id
              "
              class="form-control"
            >
              <option
                v-for="(type, i) in types"
                :value="type"
                :key="i"
                :label="type"
              >
                {{ type }}
              </option>
            </select>
        </template>
        <template #created_by="{ row, index }">
          {{ row.created_by ? row.created_by.employee.employee_name_en : '' }}
        </template>
        <template #action="{ row, index }">
            <ts-button
              v-if="
                row.branch_id == model.branch_id &&
                  row.pro_group_id == model.pro_group_id
              "
              class="btn-xs btn-primary"
              @click="update(row)"
            >
              <i class="fas fa-circle-notch spin" v-if="row._deleting"></i>
              <i class="fa fa-save" v-else></i>
            </ts-button>
            <ts-button
              @click="cancel"
              v-if="
                row.branch_id == model.branch_id &&
                  row.pro_group_id == model.pro_group_id
              "
              class="btn-xs btn-default mr-2 ml-2"
            >
              <i class="fa fa-times"></i>
            </ts-button>
            <a
              v-if="
                row.branch_id != model.branch_id ||
                  row.pro_group_id != model.pro_group_id
              "
              href="#"
              v-tooltip="$t('edit')"
              class="text-primary"
              @click.prevent="edit(row)"
            >
              <i class="fas fa-edit"></i>
            </a>
            <a-popconfirm
              placement="leftTop"
              :title="$t('are_you_sure_to_delete')"
              :ok-text="$t('yes')"
              :cancel-text="$t('no')"
              @confirm="deleteRecord(row)"
            >
              <a href="#" :disabled="row._deleting" class="ml-2">
                <i class="fas fa-circle-notch spin" v-if="row._deleting"></i>
                <i class="fa fa-trash text-red" v-else></i>
              </a>
            </a-popconfirm>
        </template>
      </Table>
      <div class="d-flex justify-content-between align-items-center p-15">
        <ts-total-list v-model="pagination" />
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
      <!-- form-action -->
      <a-modal
        v-if="showForm"
        v-model="showForm"
        :title="$t('kotBotPrinter.pageTitle')"
        centered
        @cancel="clearEdit"
        :zIndex="1020"
        :footer="null"
        width="400px"
      >
        <from-action @cancel="clearEdit" @fetchData="fetchData" />
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FromAction from './form'
import iTable from '@/store/i-table-helper'

export default {
  name: 'kotBotPrinterIndex',
  components: {
    FromAction
  },
  data() {
    return {
      loading: false,
      showForm: false,
      model: {
        branch_id: null,
        pro_group_id: null,
        printer_name: null,
        receipt_type: null
      },
      types: ['KOT', 'BOT']
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('restaurantSale/kotBotPrinter', [
      'resources',
      'pagination',
      'edit_data'
    ]),
    search: {
      get() {
        return this.$store.state.restaurantSale.kotBotPrinter.search
      },
      set(newValue) {
        this.$store.commit('restaurantSale/kotBotPrinter/SET_SEARCH', newValue)
        this.$store.commit('restaurantSale/kotBotPrinter/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        {
          key: 'column_name',
          tree: true,
          maxWidth: 15
        },
        { 
          title: this.$t('kotBotPrinter.branchName'),
          slot: 'branch_name' 
        },
        { 
          title: this.$t('kotBotPrinter.productGroup'),
          slot: 'product_group'  
        },
        { 
          title: this.$t('kotBotPrinter.printerName'),
          slot: 'printer_name'  
        },
        {
          title: this.$t('kotBotPrinter.receiptType'),
          slot: 'receipt_type',
          align: 'center'       
        },
        { 
          title: this.$t('kotBotPrinter.createdBy'),
          slot: 'created_by' 
        },
        { 
          title: this.$t('kotBotPrinter.createdDate'),
          key: 'created_date' 
        },
        {
          title: this.$t('actions'),
          key: 'action',
          slot: 'action',
          fixed: 'right',
          align: 'center',
          width: 148
        }
      ]
    },
    groupResources() {
      return iTable.rowGroup(this.resources, 'printer_name')
    }
  },
  methods: {
    handleSpan({ row, column, rowIndex, columnIndex }) {
      return iTable.handleSpan(row, columnIndex, this.columns)
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('restaurantSale/kotBotPrinter/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    addNew() {
      this.showForm = true
    },
    edit(record) {
      this.model.branch_id = record.branch_id
      this.model.pro_group_id = record.pro_group_id
      this.model.printer_name = record.printer_name
      this.model.receipt_type = record.receipt_type
    },
    clearEdit(){
      this.showForm = false
		},
    deleteRecord(record) {
      record._deleting = true
      this.$store
        .dispatch('restaurantSale/kotBotPrinter/destroy', {
          branch_id: record.branch_id,
          pro_group_id: record.pro_group_id
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          record._deleting = false
        })
    },
    branchFilter(value) {
      this.$store.commit('restaurantSale/kotBotPrinter/SET_BRANCH_ID', value)
      this.fetchData()
    },
    update(record) {
      record._deleting = true
      this.$store
        .dispatch('restaurantSale/kotBotPrinter/update', {
          id: this.model.pro_group_id,
          data: this.model
        })
        .then(response => {
          record._deleting = false
          this.$toasted.success(response.message)
          this.fetchData()
          this.cancel()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          record._deleting = false
        })
    },
    cancel() {
      this.model = {
        branch_id: null,
        pro_group_id: null,
        printer_name: null,
        receipt_type: null
      }
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData()
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('restaurantSale/kotBotPrinter/RESET_STATE')
    next()
  }
}
</script>
<style>
.ivu-table-cell-tree {
  margin-right: 10px;
}
.ivu-table-small i {
  font-size: 14px;
}
</style>
